<template lang="pug">
  .mainContainer
    el-row._pdt-155px
      el-col(:span="18")
        .header-36-black คนไข้
      el-col(:span="6").right.mgr-40px
        el-button(type="primary",style="padding: 8px 20px;", @click="createPatient").create-patient
          img(src="@/assets/icon/plus.svg", width="18px", height="18px")
    el-row.section(style="margin-bottom: 40px;")
      el-tabs(v-model="tabSelected", @tab-click="handleTabClick")
        el-tab-pane(label="ทั้งหมด", name="total")
        el-tab-pane(label="ผู้สนใจ", name="inquiry")
        el-tab-pane(label="ลูกค้า", name="customer")
    el-row.rowFilter(style="margin-top: 40px;", v-if="tabSelected==='inquiry'")
      el-col(:span="2")
        .header-text ผู้สนใจที่
      el-col(:span="18")
        el-checkbox-group(v-model="inquiry.reserved", @change="getCustomerlist")
          el-checkbox(key="ยังไม่ได้ทำการจอง", label="notReserved", border, size="medium") ยังไม่ได้ทำการจอง
          el-checkbox(key="ทำการจองแล้ว", label="reserved", border, size="medium") ทำการจองแล้ว
    el-row.rowFilter(class="_pdt-0px", v-if="tabSelected==='inquiry' && inquiry.reserved.indexOf('reserved') > -1")
      el-col(:span="2")
        .header-text มีสถานะ
      el-col(:span="18")
        el-checkbox-group(v-model="inquiry.statusSelected", @change="getCustomerlist")
          el-checkbox(v-for="status in inquiry.statuses", :key="status", :label="status", border, size="medium")
    el-row.rowFilter(class="_pdt-16px", v-if="tabSelected==='customer'")
      el-col(:span="2")
        .header-text สถานะ
      el-col(:span="18")
        el-checkbox-group(v-model="customer.statusSelected", @change="getCustomerlist")
          el-checkbox(v-for="status in customer.statuses", :key="status", :label="status", border, size="medium")
    el-row.rowFilter._pdt-8px(v-if="tabSelected==='inquiry' || tabSelected==='customer'")
      el-col(:span="2")
      el-col(:span="1.5")
        .box
          img(src="https://storage.healthathome.in.th/cc561010-da21-439c-8428-3c786f6ee441.svg", width="18px", height="18px")
          div &nbsp; &nbsp; จำนวน &nbsp; &nbsp; {{ totalItems }}
    el-row._pdl-40px.pdr-40px(v-if="tabSelected==='inquiry' || tabSelected==='customer'")
      .line-split
    el-row._pdt-32px
      patient-table(v-if="list && tabSelected==='total'", :list="list", @search="search", @didSelectRow="didSelectRow", :totalItems="totalItems", @page="pageChange", :perPage="limit", :loading="loadingTable")
      patient-table(v-if="list && tabSelected==='inquiry'", :list="list", @search="search" @didSelectRow="didSelectRow", :totalItems="totalItems", @page="pageChange", :perPage="limit", :loading="loadingTable")
      patient-table(v-if="list && tabSelected==='customer'", :list="list", @search="search" @didSelectRow="didSelectRow", :totalItems="totalItems", @page="pageChange", :perPage="limit", :loading="loadingTable")
</template>

<style lang="scss" scoped>
  .mainContainer {
    padding: 20px 100px;
  }

  ._pdt-0px {
    padding-top: 0px !important;
  }

  ._pd-0px {
    padding: 0px;
  }

  ._pdt-8px {
    padding-top: 8px !important;
  }

  ._pdt-155px {
    padding-top: 155px !important;
  }

  ._pdt-16px {
    padding-top: 16px !important;
  }

  ._pdt-32px {
    padding-top: 32px !important;
  }

  ._pdl-40px {
    padding-left: 40px !important;
  }

  ._pdr-40px {
    padding-right: 40px !important;
  }

  .right {
    text-align: right;
  }

  .el-row {
    padding-top: 16px;
    padding-left: 40px;
    padding-right: 40px;
  }

  .el-button {
    width: 120px;

    &.create-patient {
      background-color: #5489FF;
      border-color:  none;

      &:hover {
        background-color: #76a1ff;
      }

      &:active {
        background-color: #4c7be6;
      }
    }
  }

  .rowFilter {
    display: flex;
    align-items: baseline;
  }

  .header-text {
    color: #5489FF;
    font-size: 14px;
    font-weight: 600;
  }

  .box {
    padding: 9px 15px;
    width: auto;
    background-color: #F9F9FA;
    border-radius: 3.6px;
    color: #D5D6DB;
    font-weight: 700;
    font-size: 14px;
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .section {
    padding-top: 25px;
    padding-left: 40px;
    padding-right: 40px;
  }

  .el-checkbox {
    font-size: 14px;
    margin: 0 8px 8px 0;
    color: #D5D6DB;
  }

  .el-checkbox.is-bordered+.el-checkbox.is-bordered {
    margin-left: 0;
  }

  .line-split {
    height: 3px;
    background: #E4E7ED;
    margin-top: 32px;
  }

  .search-container {
    display: flex;
    justify-content: center;

    input {
      width: 346px;
      height: 40px;
      border-radius: 20px;
      border: solid 1px #dcdfe6;
      background-color: #f0f2f5;
      outline: 0;
      padding: 8px 44px 6px 44px;
      font-family: 'Sukhumvit-Medium';
      font-size: 16px;
      color: #303133;

      &::placeholder {
        font-family: 'Sukhumvit-SemiBold';
        font-size: 16px;
        color: #c0c4cc;
      }
    }

    .chat-search {
      position: fixed;
      top: 87.5px;
      left: 35.5px;
    }

    .chat-clear {
      position: fixed;
      top: 89.5px;
      left: 338px;

      &:hover {
        cursor: pointer;
      }
    }
  }
</style>

<script>
import PatientTable from '@/components/patient/PatientTable'
import PatientTableRowModel from '@/model/PatientTableRowModel'
import { GenericAPIHandler } from '@/components/shared/GenericAPIHandler'
import { Value, Storage } from '@/model/ModelUtil'

export default {
  name: 'PatientBoard',
  mixins: [GenericAPIHandler],
  mounted () {
    this.getCustomerlist()
  },
  components: {
    PatientTable,
  },
  data () {
    return {
      loadingTable: false,
      list: [],
      statusSelected: [],
      inquiry: {
        statuses: ['จอง', 'หาคน', 'รอพิจารณา', 'แมทซ์แล้ว', 'ไม่มี'],
        statusSelected: Storage.list.from('statusesInquiry') ? Storage.list.from('statusesInquiry') : [],
        reserved: Storage.list.from('reservedInquiry') ? Storage.list.from('reservedInquiry') : [],
      },
      customer: {
        statuses: ['จอง', 'หาคน', 'รอพิจารณา', 'แมทซ์แล้ว', 'ทำงานอยู่', 'ไม่มี'],
        statusSelected: Storage.list.from('statusesCustomer') ? Storage.list.from('statusesCustomer') : [],
      },
      currentPage: 1,
      perPage: 250,
      totalItems: 0,
      query: {
        type: '',
        statuses: [],
        types: [],
      },
      page: 1,
      limit: 250,
      filterText: '',
      tabSelected: this.$route.query.tab,
    }
  },
  methods: {
    async pageChange (page) {
      this.page = page
      this.limit = 250
      await this.getCustomerlist()
    },
    async search (query) {
      this.filterText = query
      await this.getCustomerlist()
    },
    async getCustomerlist () {
      this.loadingTable = true
      this.page = this.page === undefined ? 1 : this.page
      this.limit = this.limit === undefined ? 250 : this.limit
      sessionStorage.setItem('statusesCustomer', this.customer.statusSelected)
      sessionStorage.setItem('reservedInquiry', this.inquiry.reserved)
      if (this.inquiry.reserved.indexOf('reserved') === -1) {
        sessionStorage.setItem('statusesInquiry', [])
        this.inquiry.statusSelected = []
      } else {
        sessionStorage.setItem('statusesInquiry', this.inquiry.statusSelected)
      }
      switch (this.tabSelected) {
        case 'inquiry':
          this.query = {
            type: 'inquiry',
            inquiryFilter: {
              reserved: this.reservedShow(Storage.list.from('reservedInquiry')),
              statuses: this.inquiry.statusSelected.map((status) => {
                return Value.status.from(status)
              }),
            },
            customerFilter: {},
            query: this.filterText,
            page: this.page,
            limit: this.limit,
          }
          this.statusSelected = Storage.list.from('statusesInquiry')
          break
        case 'customer':
          this.query = {
            type: 'customer',
            inquiryFilter: {},
            customerFilter: {
              statuses: this.customer.statusSelected.map((status) => {
                return Value.status.from(status)
              }),
            },
            query: this.filterText,
            page: this.page,
            limit: this.limit,
          }
          this.statusSelected = Storage.list.from('statusesCustomer')
          break
        case 'total' :
          this.query = {
            type: 'all',
            inquiryFilter: {},
            customerFilter: {},
            query: this.filterText,
            page: this.page,
            limit: this.limit,
          }
          break
      }
      try {
        const raw = await this.$api.Patient.list(this.query)
        this.currentPage = raw.currentPage
        this.totalItems = raw.totalItems
        this.perPage = raw.perPage
        this.list = raw.list.map((json) => PatientTableRowModel.fromJSON(json))
        this.loadingTable = false
      } catch (error) {
        this.loadingTable = false
        this.showErrorDialog(error)
      }
    },
    reservedShow (reserved) {
      switch (reserved.length) {
        case 0: return 'all'
        case 1: return Storage.list.from('reservedInquiry')[0]
        case 2: return 'all'
        default: return ''
      }
    },
    didSelectRow (customer, event) {
      if (event.target.nodeName === 'SPAN') {
        this.$router.push({ name: 'PatientDetail', params: { id: customer.id }, query: { tab: 'workcalendarTab' } })
      } else {
        let routeData = this.$router.resolve({ name: 'PatientDetail', params: { id: customer.id }, query: { tab: 'workcalendarTab' } })
        if (this.tabSelected === 'contract') window.open(routeData.href, '_blank')
        else this.$router.push({ name: 'PatientDetail', params: { id: customer.id }, query: { tab: 'workcalendarTab' } })
      }
    },
    handleTabClick (tab, event) {
      this.page = 1
      this.limit = 100
      this.filterText = ''
      this.getCustomerlist()
      this.$router.push({ name: 'PatientBoard', query: { tab: tab.name } })
    },
    createPatient () {
      sessionStorage.setItem('lastestCustomerBoardTab', this.tabSelected)
      this.$router.push({ name: 'PatientCreate' })
    },
  },
}
</script>
